import { render } from "./FormRelManyCountries.vue?vue&type=template&id=4f670990"
import script from "./FormRelManyCountries.vue?vue&type=script&lang=js"
export * from "./FormRelManyCountries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyCountries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f670990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f670990', __exports__)) {
    console.log('reload')
    api.reload('4f670990', __exports__)
  }
  
  module.hot.accept("./FormRelManyCountries.vue?vue&type=template&id=4f670990", () => {
    console.log('re-render')
    api.rerender('4f670990', render)
  })

}


export default __exports__